import styles from './WindowLayout.module.css';

const WindowLayout = ({ title, titleComponent, content }) => {
  return (
    <div className={styles.card}>
      {(title || titleComponent) && (
        <div className={styles.header}>
          {title && <h2 className={styles.title}>{title}</h2>}
          {titleComponent && <div className={styles.action}>{titleComponent}</div>}
        </div>
      )}
      <div className={styles.body}>{content}</div>
    </div>
  );
};

export default WindowLayout;
